export default {
    "title": "Unauthorized",
    "description": "Please contact your administrator."
}
